import { authHeader, handleResponse, forDownload } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getRegionsList() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/regions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function downloadVersionFile(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };

  const { version, fileName } = queryParams;
  const endPoint = `/api/admin/v1/version-files/downloads/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(forDownload)
    .then(({ download, url }) => {
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      return download;
    });
}

function getGlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/fuses/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getChecksumAlgmList() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/version-files/checksum/algorithms`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getHM5GlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/hm5/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getHMPLUSGlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/hmplus/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getSaGlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/sa/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getUAGlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/ua/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getVs2jen2GlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/vs2jen2/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getVs2ngaGlobalReleases() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/vs2nga/global/available/versions`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const commonService = {
  getRegionsList,
  downloadVersionFile,
  getGlobalReleases,
  getChecksumAlgmList,
  getHM5GlobalReleases,
  getSaGlobalReleases,
  getVs2jen2GlobalReleases,
  getUAGlobalReleases,
  getVs2ngaGlobalReleases,
  getHMPLUSGlobalReleases,
};
